module.exports = __webpack_public_path__ + "assets/img/pctmn-news.22cc01c4.png";